import axios from "axios"

async function getJsonFile (stp, callback1, callback2, statusCallback) {
    try {
        var timestamp = new Date().getTime();
        var file1 = false;
        var file2 = false;

        var fileName1 = "kyotsuKakakuJoho.json";
        var PFilePath1 = "./data/" + fileName1 + "?timestamp=" + timestamp;
        const res1 = await axios.get(PFilePath1);
        const kyotsuKakakuJoho = res1.data;

        const planData1 = kyotsuKakakuJoho.filter(item => item.hokenryoHyj == stp );
        if (planData1.length > 0) {
            file1 = true;
        } else {
            file1 = false;
        }

        var fileName2 = "planSekkeiKekka.json";
        var PFilePath2 = "./data/" + fileName2 + "?timestamp=" + timestamp;
        const res2 = await axios.get(PFilePath2);
        const planSekkeiKekka = res2.data;

        const planData2 = planSekkeiKekka.filter(item => item.tsukibaraiHokenryo == planData1[0].tsukibaraiHokenryo )
        if (planData2.length > 0) {
            file2 = true;
        } else {
            file2 = false;
        }

        if (file1 && file2) {
            callback1(planData1);
            callback2(planData2);
            statusCallback(true);
        } else {
            statusCallback(false);
        }

    } catch (error) {
        statusCallback(false);
    }
}
export default {getJsonFile}